<template>
  <div class="relative">
    <div
      class="lg:py-0 md:py-0 py-12 lg:flex md:flex lg:gap-10 md:gap-10 justify-between"
    >
      <!-- <div class="absolute bg-design11 mob-hidden">
        <img
          src="../../../assets/images/bg-des/bgd11.svg"
          alt="bg-polygon"
          class=""
        />
      </div>
      <div class="absolute bg-design12">
        <img
          src="../../../assets/images/Ellipse 12.svg"
          alt="bg-polygon"
          class="h-full"
        />
      </div> -->
      <div
        class="lg:w-1/2 md:w-1/2 w-full lg:pt-0 md:pt-0 lg:ml-auto md:ml-auto"
      >
        <div class="lg:my-auto md:my-auto">
          <p class="title-home sm-fsize16 lg:font-medium md:font-medium font-bold">
            Why us
          </p>
          <div class="">
            <p
              class="subtitle md-fsize16 lg:pt-0 md:pt-0 pt-2 lh30px sm-lh26 sm-fsize13 md-ellipsis-8"
            >
              Today, urban living creates caregiving challenges, with a need for
              holistic support. Besides medical expenses and education, our
              research indicates that caregivers’ primary needs include
              emotional support and a range of professional services including a
              trustworthy care assistant.

              <span class="">
                This helps ensure a smoother and pleasurable caregiving journey
                without regrets for the family and the care-receiver troubled by
                infirmity from age or a medical condition!</span
              >
              <!-- <span v-if="readmore"></span><span v-else>...</span> -->
            </p>
            <div>
              <p
                class="subtitle lg:pt-8 md:pt-8 pt-4 lh32px sm-fsize13 mob-hidden"
              >
                Subscription to our services provide caregivers with access to a
                ‘Saathi’, a companion who not only understands caregiving
                challenges but also provides emotional support through this
                potentially roller-coaster journey.
              </p>
            </div>
          </div>
          <!-- <p class="cursor-pointer" @click="readmore = !readmore">
          <span class="fsize15 sm-fsize14 text-063a88 underline" v-if="readmore"
            >Read less</span
          >
          <span class="fsize15 sm-fsize14 text-063a88 underline" v-else
            >Read more</span
          >
        </p> -->
          <div class="lg:pt-8 md:pt-6 pt-4">
            <base-button
              outline
              type="primary"
              class="md:px-8 lg:px-8 px-6 md:py-3 lg:py-3 py-1 fs16700 border-2"
              @click="handleClick('about-us')"
              >Read More</base-button
            >
          </div>
        </div>
      </div>
      <div class="lg:w-1/2 md:w-1/2 w-full lg:pt-0 md:pt-0 pt-8">
        <img
          src="https://nimbuscluster.blob.core.windows.net/server01/caregiversaathi/CG/homepage/Why-us.webp"
          alt=""
          class="m-auto custborderradius h-330px sm-h250px"
        />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      readmore: false,
    };
  },
  methods: {
    handleClick(name) {
      this.$router.push({ name: name });
    },
  },
  computed: {
    windowWidth() {
      return this.$store.state.windowWidth;
    },
  },
};
</script>
<style>
@media (min-width: 641px) {
  .topmis105 {
    top: -105px;
  }
}
</style>
